<template>
  <g>
    <defs>
      <linearGradient
        id="linear-gradient"
        x1="0.5"
        x2="0.5"
        y2="1"
        gradient-units="objectBoundingBox"
      >
        <stop
          offset="0"
          stop-color="#4fb6d7"
        />
        <stop
          offset="1"
          stop-color="#68dadb"
        />
      </linearGradient>
    </defs>
    <g
      id="ic_mentor_top"
      transform="translate(-423 -368)"
    >
      <rect
        id="Rechteck_510"
        data-name="Rechteck 510"
        width="24"
        height="24"
        transform="translate(423 368)"
        fill="none"
      />
      <g
        id="ic_mentor_top-2"
        data-name="ic_mentor_top"
        transform="translate(422.5 370)"
      >
        <path
          id="Pfad_1051"
          data-name="Pfad 1051"
          d="M12.717,0a.626.626,0,0,0-.259.056L.873,4.8a.538.538,0,0,0,0,1.025L3.605,6.944v5.009c0,.816,3.871-1.1,4.533-.589,1.411,1.1.854,2.849,2.112,4.475a6.292,6.292,0,0,0,2.469.484,12.245,12.245,0,0,0,7.6-2.3A2.542,2.542,0,0,0,21.4,11.959V7L24.15,5.844a.626.626,0,0,0,.351-.532A.57.57,0,0,0,24.15,4.8L12.978.056A.626.626,0,0,0,12.717,0Zm-.01,1.2,9.7,4.118-9.7,4.118L4.465,6.052l-1.82-.741ZM23.874,6.641a.586.586,0,0,0-.626.57V10.8a.626.626,0,0,0,1.242,0V7.211a.586.586,0,0,0-.616-.57ZM4.839,7.457l7.613,3.112a.591.591,0,0,0,.248.056,14.34,14.34,0,0,0,3.932.417v3.644a12.654,12.654,0,0,1-6,.273c-1.411-.288-.561-2.663-2.5-4.162-.371-.3-3.293,1.632-3.293,1.158Z"
          transform="translate(0 0)"
        />
        <g
          id="ic_top_badge"
          transform="translate(0.868 9.599)"
        >
          <rect
            id="Rechteck_506"
            data-name="Rechteck 506"
            width="8.838"
            height="10.311"
            transform="translate(0.37 0.96)"
            fill="none"
          />
          <g
            id="icon_official_badge"
            transform="translate(0 0)"
          >
            <path
              id="Differenzmenge_5"
              data-name="Differenzmenge 5"
              d="M4.411,9.7a.639.639,0,0,1-.521-.265l-.152-.2A.657.657,0,0,0,3.035,9L2.8,9.07a.645.645,0,0,1-.181.026.638.638,0,0,1-.631-.529L1.941,8.32a.629.629,0,0,0-.531-.514l-.249-.043a.66.66,0,0,1-.45-.3.61.61,0,0,1-.07-.5l.1-.247a.626.626,0,0,0-.249-.7l-.206-.14a.62.62,0,0,1-.119-.942l.162-.182A.621.621,0,0,0,.4,4.014L.273,3.8a.637.637,0,0,1,.314-.9l.227-.1a.645.645,0,0,0,.39-.632l-.022-.247a.61.61,0,0,1,.161-.468.644.644,0,0,1,.474-.207h.037l.249.01.048,0a.622.622,0,0,0,.58-.4l.1-.236a.657.657,0,0,1,.6-.4.644.644,0,0,1,.306.078l.217.118a.635.635,0,0,0,.312.082A.657.657,0,0,0,4.7.339L4.887.168a.643.643,0,0,1,.953.1l.152.214a.657.657,0,0,0,.7.236L6.934.639a.641.641,0,0,1,.812.5l.043.246A.629.629,0,0,0,8.32,1.9l.249.043a.66.66,0,0,1,.45.3.61.61,0,0,1,.07.5l-.065.236a.626.626,0,0,0,.249.7l.206.139a.621.621,0,0,1,.269.452.614.614,0,0,1-.171.491l-.162.182a.62.62,0,0,0-.076.739l.13.214a.637.637,0,0,1-.314.9l-.227.1a.645.645,0,0,0-.39.633l.011.246a.61.61,0,0,1-.161.469.644.644,0,0,1-.474.207H7.876l-.25-.011-.048,0a.622.622,0,0,0-.58.4l-.1.235a.657.657,0,0,1-.6.4.642.642,0,0,1-.306-.078l-.217-.118a.642.642,0,0,0-.313-.083.657.657,0,0,0-.435.168l-.184.171A.64.64,0,0,1,4.411,9.7ZM3.431,4.111l-.888.879L4.266,6.718,7.185,3.853l-.879-.879L4.289,4.96Z"
              transform="translate(0 0)"
              fill="url(#linear-gradient)"
            />
          </g>
        </g>
      </g>
    </g>
  </g>
</template>
